// Settings.tsx
import classes from './Settings.module.sass'
import { Toggle } from '../../common/components/toggle/Toggle'
import { useSettings } from './hooks/useSettings'
import { Button } from '../../common/components/button/Button'
import { Helmet } from 'react-helmet-async'
import { selectCurrentUser } from '../../store/slices/currentUserSlice'
import { useSelector } from 'react-redux'
import { ColorSchemeSelector } from '../../common/components/colorSchemeSelector/ColorSchemeSelector'

export const Settings = () => {
  const {
    darkTheme,
    soundEnabled,
    toggleThemeAction,
    toggleSoundAction,
    setPaymentModalState,
    contacts,
  } = useSettings()
  const currentUser = useSelector(selectCurrentUser)

  return (
    <div className={classes.Container}>
      <Helmet>
        <title>{`logid - настройки`}</title>
        <meta
          name="description"
          content={`Настройки. Поставить темную тему, пополнить баланс, заполнить профиль`}
        />
      </Helmet>
      <div className={classes.Header}>Настройки</div>

      <div className={classes.Card}>
        <div className={classes.ToggleContainer}>
          <Toggle id={'theme'} onChange={toggleThemeAction} checked={darkTheme} />
          <div>темная тема</div>
        </div>

        <div className={classes.ToggleContainer}>
          <Toggle
            id={'sound'}
            onChange={() => toggleSoundAction(!soundEnabled)}
            checked={soundEnabled ?? true}
          />
          <div>звуковые уведомления</div>
        </div>

        <div className={classes.ColorSection}>
          <div className={classes.ColorTitle}>Цветовая схема</div>
          <ColorSchemeSelector />
        </div>

        {/* <div className={classes.ContactsContainer}>
          <div className={classes.ContactsCount}>{contacts}</div>
          <div>доступных контактов</div>
          <div>
            <Button text="Добавить" small onClick={() => setPaymentModalState(true)} />
          </div>
        </div> */}
      </div>
    </div>
  )
}
